import * as React from "react";
import {getTranslation} from "../../utils/translationUtil";

export const TAGLINE = "Aon is in the Business of Better Decisions and better decisions start with better insight. Iris gives institutional investors advanced analytics, expert perspective, and 360° insights to help drive stronger portfolio outcomes.";
export const POWERED_BY = "Iris is powered by Aon’s Strategic Client Delivery";

export const HomeHeader: React.FunctionComponent = () => {
    return <section className="home-header__welcome-section" data-testid="home-header__container">
        <div className="home-header__welcome-inner">
            <h1 className="home-header__welcome-title">
                {getTranslation("home.welcome-title", "Welcome to Iris")}
            </h1>
            <p className="home-header__welcome-description">
                {getTranslation("home.welcome-tagline", TAGLINE)}
                <br/>
                <span className="home-header__powered-by">
                    {getTranslation("home.powered-by", POWERED_BY)}
                </span>
            </p>
        </div>
    </section>;
};